import { findingsContent } from "./findingsContent"

const headingClass =
  "text-balance text-[40px] font-bold leading-[48px] tracking-[-0.04em] text-[#171717] max-md:text-[28px] max-md:leading-8"

export default function FindingsSection() {
  return (
    <section
      id="key-findings"
      className="flex w-full scroll-mt-20 translate-x-[calc(50vw-50%-1.5rem)] flex-col gap-8"
    >
      <div className="flex flex-col gap-3">
        <p className="text-[14px] font-medium leading-5 text-[#4D4D4D]">{findingsContent.eyebrow}</p>
        <h2 className={headingClass}>{findingsContent.title}</h2>
      </div>
      <ol className="m-0 flex max-w-[68ch] list-decimal flex-col gap-6 pl-5 text-[16px] font-normal leading-6 text-[#4D4D4D]">
        {findingsContent.points.map((point) => (
          <li key={point.title}>
            <span className="font-bold text-[#171717]">{point.title}</span>{" "}
            {point.before}
            {point.emphasis ? <strong className="font-bold text-[#171717]">{point.emphasis}</strong> : null}
            {point.after}
          </li>
        ))}
      </ol>
    </section>
  )
}
